import React from 'react'
import ContainerPages from '../../ContainerPages'
import AccountSettings from '../../../components/account/settings/index'

export default function Container() {
  return <ContainerPages component={AccountSettings} />
}
